import { supabase } from './supabaseClient'
import type { UserDataExport } from './exportUserDataTypes'

export type { UserDataExport } from './exportUserDataTypes'

type ExportUserDataResponse = {
  ok?: boolean
  export?: UserDataExport
  error?: string
}

function exportFilename(): string {
  const date = new Date().toISOString().slice(0, 10)
  return `kilo-data-export-${date}.json`
}

export async function downloadUserDataExport(): Promise<{ ok: boolean; error?: string }> {
  const { data, error } = await supabase.functions.invoke<ExportUserDataResponse>('export-user-data', {
    body: {},
  })

  if (error) {
    return { ok: false, error: error.message }
  }

  if (!data?.ok || !data.export) {
    return { ok: false, error: data?.error ?? 'Export failed' }
  }

  const blob = new Blob([JSON.stringify(data.export, null, 2)], {
    type: 'application/json;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = exportFilename()
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)

  return { ok: true }
}
